import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import React from "react";
import myRestClient from "../common/restClient";
import TranslatedText from "./TranslatedText";
import { PER_PAGE_MAX_LIMIT } from "../config";

class FilteredRoleSelect extends React.Component {
    state = { roles: [], default_value: 1 };

    componentDidMount() {
        const query = {
            id: this.props.record.role_id
        };
        if (query.id) {
            myRestClient("GET_ONE", "roles", query).then(
                result => {
                    this.setState({ default_value: result.data.id });
                },
                error => {
                    return error;
                }
            );
        }
        const params = {
            filter: { company_to_edit_id: this.props.record.company_id },
            pagination: { page: 1, perPage: PER_PAGE_MAX_LIMIT },
            sort: { field: "name", order: "asc" }
        };
        myRestClient("GET_LIST", "roles", params).then(
            result => {
                this.setState({ roles: result.data });
            },
            error => {
                return [];
            }
        );
    }

    handleChange = event => {
        this.props.input.onChange(event.target.value);
        this.setState({ default_value: event.target.value });
    };

    renderMenuItems = () => {
        const roles = this.state.roles
            ? this.state.roles.map(param => {
                  return (
                      <MenuItem value={param.id} key={param.id + param.name}>
                          {param.description}
                      </MenuItem>
                  );
              })
            : [];
        return roles;
    };

    render() {
        return (
            <FormControl style={{ width: 256 }}>
                <InputLabel htmlFor="role_id_select">
                    <TranslatedText resource_name="resources.role-mappings.fields.role_id" />
                </InputLabel>
                <Select
                    value={this.state.default_value}
                    onChange={this.handleChange}
                    inputProps={{
                        name: "role_id",
                        id: "role_id_select"
                    }}
                >
                    {this.renderMenuItems()}
                </Select>
            </FormControl>
        );
    }
}

FilteredRoleSelect.defaultProps = {
    addField: true
};

export default FilteredRoleSelect;



// WEBPACK FOOTER //
// ./src/components/FilteredRoleSelect.js